import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import PageNotFound from '../views/PageNotFound.vue'
import OrderReview from '../views/OrderReview.vue'
import OrderHistory from '../views/OrderHistory.vue'
import OrderView from '../views/OrderView.vue'
import OrderViewAdmin from '../views/OrderViewAdmin.vue'
import Cart from '../views/Cart.vue'
import Checkout from '../views/Checkout.vue'
import Login from '../views/Login.vue'
import Product from '../views/Product.vue'
import Category from '../views/Category.vue'
import Subcategory from '../views/Subcategory.vue'
import Account from '../views/Account.vue'
import Thankyou from '../views/Thankyou.vue'
import UpdateProfile from '../views/UpdateProfile.vue'
import CreateAccount from '../views/CreateAccount.vue'
import ChangePassword from '../views/ChangePassword.vue'
import ForgotPassword from '../views/ForgotPassword.vue'
import UpdateBillingAddress from '../views/UpdateBillingAddress.vue'
import UpdateDeliveryAddress from '../views/UpdateDeliveryAddress.vue'
import PostError from '../views/PostError.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: Home
  },
  {
    path: '/home',
    name: 'home',
    component: Home
  },
  {
    path: '/update-profile',
    name: 'UpdateProfile',
    component: UpdateProfile
  },
  {
    path: '/update-billing-address',
    name: 'UpdateBillingAddress',
    component: UpdateBillingAddress
  },
  {
    path: '/create-account',
    name: 'CreateAccount',
    component: CreateAccount
  },
  {
    path: '/change-password',
    name: 'ChangePassword',
    component: ChangePassword
  },
  {
    path: '/forgot-password',
    name: 'ForgotPassword',
    component: ForgotPassword
  },
  {
    path: '/update-delivery-address',
    name: 'UpdateDeliveryAddress',
    component: UpdateDeliveryAddress
  },  
  {
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  },
  {
    path: '/contact',
    name: 'Contact',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/Contact.vue')
  },
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/account',
    name: 'Account',
    component: Account
  },
  {
    path: '/cart',
    name: 'Cart',
    component: Cart
  },
  {
    path: '/order-review',
    name: 'OrderReview',
    component: OrderReview
  },
  {
    path: '/order-history',
    name: 'OrderHistory',
    component: OrderHistory
  },
  {
    path: '/order-view',
    name: 'OrderView',
    component: OrderView
  },
  {
    path: '/site/admin/order-view',
    name: 'OrderViewAdmin',
    component: OrderViewAdmin
  },
  {
    path: '/thankyou',
    name: 'Thankyou',
    component: Thankyou
  },
  {
    path: '/checkout',
    name: 'Checkout',
    component: Checkout
  },
  {
    path: '/response-error',
    name: 'PostError',
    component: PostError
  },
  {
    path: '/404',
    name: 'PageNotFound',
    component: PageNotFound
  },  
  {
    path: '/category/:categoryId',
    name: 'Subcategory',
    component: Subcategory
  },
  {
    path: '/:categoryId/:productId',
    name: 'Product',
    component: Product
  },  
  {
    path: '/:categoryId',
    name: 'Category',
    component: Category
  },
  {
    path: '*',
    name: 'home',
    component: Home
  },  
]


const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
